module.exports = __webpack_public_path__ + "static/media/profile_picture.21143d2d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/template/navigation/profile_picture.jpeg
// module id = 142
// module chunks = 0